import verge from 'verge'
const debounce = require('throttle-debounce/debounce');

class Iframe {
    constructor(elem) {
        this.url = $(elem).data('url')
        this.container = elem
        this.show = false
        this.ratio = $(elem).data('ratio') ? $(elem).data('ratio') : 2.04
    }

    init() {
        this.iframe = document.createElement('iframe')
        this.setSize()
        this.iframe.setAttribute('src', this.url)

        this.checkVieportAndShow()
    }

    setSize() {
        $(this.container).removeAttr('style')
        const width = $(this.container).width()
        const height = width/this.ratio

        $(this.container).width(width)
        $(this.container).height(height)
    }

    checkVieportAndShow() {
        if (verge.inViewport(this.container) && !this.show) {
            this.container.innerHTML = '';
            this.container.append(this.iframe)

            this.show = true
        }
    }

    resize () {
        this.setSize()
    }
}

const $iframe = $('.iframe-container')

if($iframe.length) {
    $iframe.each((index, item) => {
        const iframe = new Iframe(item)
        iframe.init()

        $(window).on('scroll', debounce(100, (e) => iframe.checkVieportAndShow()))
        $(window).on('resize', debounce(100, (e) => iframe.setSize()))
    })
}



// WEBPACK FOOTER //
// ./frontend/components/iframe/iframe.js